module.exports = __webpack_public_path__ + "static/media/08.503df1f1.png";